import HeatmapLayer from "react-google-maps/lib/components/visualization/HeatmapLayer";

/* eslint-disable no-undef */
import React, { Component } from 'react';
import { withGoogleMap, GoogleMap } from 'react-google-maps';
import { compose, withProps, lifecycle } from 'recompose';


export default class HeatMap extends Component {

    render() {
        const MyMapComponent = compose(
            withProps({
                loadingElement: (<div style={{ height: '100%' }} />),
                containerElement: (<div style={{ height: '230px' }} />),
                mapElement: (<div style={{ height: '100%' }} />)
            }),
            withGoogleMap,
            lifecycle({
                componentDidMount() {

                }
            })
        )(props => {
            console.log('props: ', props);
            const  data  = props &&
                props.loadingElement && props.loadingElement._self &&
                props.loadingElement._self.props && props.loadingElement._self.props.data;
            let heatMap = [];
            if (data) {
                heatMap = data.map(position => {
                    return new window.google.maps.LatLng(position[1], position[0])
                });
            }
            return (
                <div>
                    <GoogleMap defaultZoom={ 7 } defaultCenter={heatMap[0] ? heatMap[0] : new window.google.maps.LatLng(37.782551, -122.445368)}>
                        <HeatmapLayer data={ heatMap } />
                    </GoogleMap>
                </div>
            );
        });

        return(
            <MyMapComponent/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/HeatMap/HeatMap.js